import httpInstance from '../httpInstance';

const createBannerService = async (dataParam) => {
  let res;
  const endpoint = '/frontlabels/v1/promos';
  const dataSent = dataParam;

  await httpInstance.post(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default createBannerService;
